<!--
    @负责人: libaiqi
    @创建时间: 2018-09-04
    @版本:v1.0.22
    @描述: 仓库
    -->
<template>
  <div class="repertory__content">
    <div class="repertory__form">
      <el-form ref="form" :model="form" :inline="true" input-width="auto">
        <el-form-item>
          <el-input v-model="form.resourceName" :placeholder="$t('repertory.inputSearch')"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="e_search" v-g-rac="gRac('repertory@search')">{{ $t('common.search') }}</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="repertory__icon">
      <div v-for="(value,key) in modelList" :key="key" class="repertory__mb10">
        <div class="repertory__list repertory__mb10" >{{value}}</div>
        <div v-for="(item,index) in resourceList[key]" :key="index" class="repertory__item repertory__ilb repertory__mb10" :title="item.resourceName">
          <img class="repertory__img" src='../../../assets/image/cmdb/resorce.png'  @click="toInstance(item)">
          <div class="repertory__mb10">{{item.resourceName}}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import rac from '@/plugins/rac-mixin'
  import dic from '@/components/mixins/dic'
  import resourceModelBiz from '@/logic/cmdb/resourceModelBiz'
  import dialogForm from '@/components/dialogForm'
  export default {
    mixins: [rac, dic],
    components: {
      dialogForm
    },
    data () {
      return {
        form: {
          resourceName: ''
        },
        modelList: {},
        resourceList: {},
        list: [],
        flag: 0
      }
    },
    methods: {
      e_init () {
        this.waitResourceTypeList()
      },
      async waitResourceTypeList () {
        await this.dGetDictionaryByCode('resourcemodel')
        this.modelList = { ...this.dDictionary.resourcemodel }
        this.getResource()
      },
      getResource (obj) {
        resourceModelBiz.getResource(obj).then((d) => {
          this.list = d
          this.flag++
        })
      },
      e_search () {
        this.getResource({resourceName: this.form.resourceName})
      },
      toInstance (data) {
        let query = {}
        query.resourceName = data.resourceName
        query.flagId = data.flagId
        query.resourceType = data.resourceType
        this.$router.push({ name: 'repertoryInstance', query: query })
      }
    },
    mounted () {
      this.e_init()
    },
    watch: {
      flag () {
        if (this.flag >= 1) {
          let list = {}
          Object.keys(this.modelList).forEach((item) => {
            list[item] = this.list.filter(({resourceType}) => resourceType === item)
          })
          this.resourceList = list
        }
      },
      $route (newV, oldV) {
        if ((oldV.name === 'resourceManage' || oldV.name === 'resourceModel' || oldV.name === 'repertoryInstance') && newV.name === 'repertory') {
          this.getResource()
        }
      }
    }
  }
</script>
<style scoped>
  .repertory__content .repertory__icon {
    font-size: 14px;
  }
  .repertory__content .repertory__mb10 {
    margin-bottom: 10px;
  }
  .repertory__content .repertory__list{
    font-weight: 700;
  }
  .repertory__content .repertory__ilb{
    display: inline-block;
  }
  .repertory__content .repertory__img{
    margin: 0 auto;
    display: block; 
    cursor: pointer; 
  }
  .repertory__content .repertory__item{
    width: 120px;
  }
  .repertory__content .repertory__item div{
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>
